import React from "react";
import "./Grow_Your_Local_Reach.css";

const Grow_Your_Local_Reach = () => {
  const offersData = [
    {
      title: "Get discovered by local buyers",
      icon: "/assets/images/home/grow_your_local_reach/img1.png",
    },
    {
      title: "Promote your products & services",
      icon: "/assets/images/home/grow_your_local_reach/img2.png",
    },
    {
      title: "Build trust in your city",
      icon: "/assets/images/home/grow_your_local_reach/img3.png",
    },
    {
      title: "Increase sales digitally",
      icon: "/assets/images/home/grow_your_local_reach/img4.png",
    },
    {
      title: "Join the city network",
      icon: "/assets/images/home/grow_your_local_reach/img5.png",
    },
  ];

  return (
    <section className="Grow_Your_Local_Reach">
      <div className="container">
        <div className="section-header text-center">
          <h2>Grow Your Local Reach</h2>
          <p>
            Loconex helps vendors and farmers reach real customers nearby.
          </p>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="row justify-content-center">
              {offersData.map((item, index) => (
                <div className="col-sm-6">
                  <div className="offer-card" key={index}>
                    <img src={item.icon} alt={item.title} />
                    <h5>{item.title}</h5>
                  </div>
                </div>
              ))}
            </div>

           
          </div>
          <div className="col-lg-5">
            <div className="img_holder">
              <img src="/assets/images/home/grow_your_local_reach/grow.jpg" className="right_img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Grow_Your_Local_Reach;
